/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import axios from '@/axios.js'
import { copyWithin } from 'core-js/fn/array'
import axios from '../../http/axios/index.js'

import SwaggerClient from 'swagger-client'
import { SwaggerDefinition, ApiKey } from '@/apiConfig.js'

function getBearer() {
  return localStorage.getItem('accessToken')
}

export default {
  removeHobject({ commit }, hobjectPid) {
    return SwaggerClient.execute({
      spec: SwaggerDefinition,
      operationId: 'deleteHobject',
      parameters: { pid: hobjectPid },
      securities: { authorized: { PrivateKey: ApiKey, Bearer: getBearer() } },
    }).then(res => {
      commit('REMOVE_HOBJECT', hobjectPid)
    })
  },
  askS3permission({ commit }, file) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/s3/sign?file-type=${file.type}&layer-name=${
            JSON.parse(localStorage.getItem('layerInfo')).name
          }&file-ext=${file.name.split('.').pop()}`
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  uploadToS3({ commit }, data) {
    return new Promise((resolve, reject) => {
      console.log('uploadToS3uploadToS3')
      console.log(data)

      delete axios.defaults.headers['Authorization']

      axios
        .put(data.signedRequest, data.file, {
          headers: {
            'Content-Type': data.file.type,
          },
          onUploadProgress: progressEvent => {
            // console.log(progressEvent);
          },
          onDownloadProgress: progressEvent => {},
        })
        .then(response => {
          axios.defaults.headers['Authorization'] = localStorage.getItem('accessToken')
          resolve(response)
        })
        .catch(error => {
          axios.defaults.headers['Authorization'] = localStorage.getItem('accessToken')
          reject(error)
        })
    })
  },
  async postHobject({ commit }, hobject) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'postHobject',
        requestBody: hobject,
        securities: {
          authorized: { PrivateKey: ApiKey, Bearer: getBearer() },
        },
      })
        .then(res => {
          console.log('res.body')

          console.log(res.body)
          commit('ADD_HOBJECT', res.body)
          resolve(res.body)
        })
        .catch(e => reject(e))
    })
  },
  async postLink({ commit }, link) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'postLink',
        parameters: link,
        securities: {
          authorized: { PrivateKey: ApiKey, Bearer: getBearer() },
        },
      })
        .then(res => {
          console.log('res.body')

          console.log(res.body)
          commit('ADD_LINK', res.body)
          resolve(res.body)
        })
        .catch(e => reject(e))
    })
  },

  updateHobject({ commit }, hobject) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'putHobject',
        parameters: { pid: hobject.pid },
        requestBody: hobject,
        securities: { authorized: { PrivateKey: ApiKey, Bearer: getBearer() } },
      })
        .then(res => {
          commit('UPDATE_HOBJECT', res.body)
          resolve(res.body)
        })
        .catch(e => reject(e))
    })
  },
  updateLink({ commit }, link) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'putLink',
        parameters: link,
        requestBody: link,
        securities: {
          authorized: { PrivateKey: ApiKey, Bearer: getBearer() },
        },
      })
        .then(res => {
          commit('UPDATE_LINK', res.body)
          resolve(res.body)
        })
        .catch(e => reject(e))
    })
  },
  getLayerLinks({ commit }, params) {
    return SwaggerClient.execute({
      spec: SwaggerDefinition,
      operationId: 'getLayerLinks',
      parameters: params,
      securities: { authorized: { PrivateKey: ApiKey, Bearer: getBearer() } },
    }).then(res => {
      console.log(res.body.links)
      commit('SET_LINK', res.body.links)
      var hobjects = []
      res.body.links.forEach(link => {
        let height = ''
        if (link.hobjects[0].model_identifier == 'hoverlay.art.WallArt.1.0') {
          try {
            height = JSON.parse(link.hobjects[0].abilities).skin.height
            if (isNaN(height)) height = 1
          } catch (error) {
            console.log(error)
            height = 1
          }
        }
        if (link.hobjects[0].model_identifier == 'hoverlay.core.3dModel.1.0') {
          try {
            height = JSON.parse(link.hobjects[0].abilities).gltf_loader.height
          } catch (error) {
            console.log(error)
          }
        }
        link.hobjects[0].height = height
        hobjects.push(link.hobjects[0])
      })
      commit('SET_HOBJECT', hobjects)
    }) // => Promise.<Response>
  },
  getUserMeLayer({ commit }) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'getUserLayers',
        securities: {
          authorized: { PrivateKey: ApiKey, Bearer: getBearer() },
        },
      })
        .then(res => {
          resolve(res.body)
        })
        .catch(e => reject(e))
    })
  },
  getAuthenticatedUser({ commit }) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'getAuthenticatedUser',
        securities: { authorized: { PrivateKey: ApiKey, Bearer: getBearer() } },
      })
        .then(res => {
          if (res.body) {
            localStorage.setItem('userInfo', JSON.stringify(res.body))
            resolve(res.body)
          }
          store.commit('UPDATE_USER_INFO', res.body)
        })
        .catch(e => reject(e))
    })
  },
  getLayerContent({ commit }) {
    return SwaggerClient.execute({
      spec: SwaggerDefinition,
      operationId: 'getUserContent',
      securities: { authorized: { PrivateKey: ApiKey, Bearer: getBearer() } },
    }).then(res => {
      commit('SET_HOBJECT', res.body.hobjects)
      res.body.hobjects.forEach(hobject => {
        let height = ''
        if (hobject.model_identifier == 'hoverlay.art.WallArt.1.0') {
          try {
            height = JSON.parse(hobject.abilities).skin.height
            if (isNaN(height)) height = 1
          } catch (error) {
            console.log(error)
            height = 1
          }
        }
        if (hobject.model_identifier == 'hoverlay.core.3dModel.1.0') {
          try {
            height = JSON.parse(hobject.abilities).gltf_loader.height
          } catch (error) {
            console.log(error)
          }
        }
        hobject.height = height
      })
      commit('SET_HOBJECT', res.body.hobjects)
    }) // => Promise.<Response>
  },
  getLayer({ commit }, params) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'getLayer',
        parameters: { pid: params.pid },
        securities: { authorized: { PrivateKey: ApiKey, Bearer: getBearer() } },
      }).then(res => {
        console.log(res.body)
        resolve(res.body)
      })
    })
  },
  fetchMoreLayerLinks({ commit }, params) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'getLayerLinks',
        parameters: { name: params.layer_name, page: params.page, per: params.per },
        securities: { authorized: { PrivateKey: ApiKey, Bearer: getBearer() } },
      }).then(res => {
        res.body.links.forEach(link => {
          commit('ADD_LINK', link)
        })
        //commit('SET_LINK', res.body.links)
        console.log(res.body)
        resolve(res.body)
      })
    })
  },
  sendAccountConfirmationEmail({ commit }, params) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'sendAccountConfirmationEmail',
        parameters: params,
        securities: { authorized: { PrivateKey: ApiKey, Bearer: getBearer() } },
      })
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  confirmAccount({ commit }, token) {
    return new Promise((resolve, reject) => {
      return SwaggerClient.execute({
        spec: SwaggerDefinition,
        operationId: 'confirmAccount',
        parameters: token,
        securities: { authorized: { PrivateKey: ApiKey } },
      })
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
}
